import type { GeneratedPackageChanges } from './GeneratedPackageChanges.js';
import type { InitPackageResultErrors, InitPackageResultWarnings } from './InitPackageResult.js';

export interface InitSummary {
  appPath: string;
  duration: number;
  /** True if there were errors, or if `check` was set and there were required changes. */
  failed: boolean;
  /** Total number of packages */
  totalPackages: number;
  /** Total packages without errors (doesn't consider required config changes) */
  totalSuccess: number;
  /** Total number of errors (doesn't include required config changes) */
  totalErrors: number;
  /** Total number of warnings (doesn't include config changes) */
  totalWarnings: number;
  /** Total number of changes made to the generated config */
  totalChanges: number;
  /**
   * Total number of required changes made to the generated config.
   * This will cause `init --check` to fail if it's not 0.
   */
  totalRequiredChanges: number;
  /** If true, the generated config previously existed but is now not needed and was deleted */
  deletedGeneratedConfig?: boolean;
  /** Updates made to the generated config */
  generatedFileUpdates: GeneratedPackageChanges[];
  /** Results for each package with errors (doesn't include required config changes) */
  packagesWithErrors: InitPackageResultErrors[];
  /** Results for each package with warnings (doesn't include config changes) */
  packagesWithWarnings: InitPackageResultWarnings[];
}
